import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { AppSharedModule } from '../../app-shared.module';
import { CompareBannerComponent } from '../../components/compare-banner/compare-banner.component';
import { VolvoPipesModule } from '../../core/pipes/volvo-pipes.module';
import { ListCardComponent } from './components/list-card/list-card.component';
import { OverviewCardComponent } from './components/overview-card/overview-card.component';
import { FavoriteVehiclesComponent } from './pages/favorite-vehicles/favorite-vehicles.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { AdminAssetsService } from './services/admin-assets.service';
import { AdminPageService } from './services/admin-page.service';
import { InternalDetailsChartCardService } from './services/charts.service';
import { CustomerNotificationsService } from './services/customer-notifications.service';
import { InternalFilterService } from './services/filter.service';
import { InternalTruckCardService } from './services/truck-card.service';
import { AdminState } from './store/reducers/admin.reducers';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        NgxsModule.forFeature([AdminState]),
        TranslateModule.forChild(),
        LocalizeRouterModule,
        VolvoPipesModule,
        AppSharedModule
    ],
    declarations: [
        OverviewCardComponent,
        ListCardComponent,
        OverviewComponent,
        CompareBannerComponent,
        MyProfileComponent,
        FavoriteVehiclesComponent
    ],
    providers: [
        AdminAssetsService,
        InternalDetailsChartCardService,
        InternalTruckCardService,
        AdminPageService,
        InternalFilterService,
        CustomerNotificationsService,
    ],
    exports: [
        NgxsModule,
        VolvoPipesModule,
        CompareBannerComponent,
        MyProfileComponent
    ]
})
export class AdminSharedModule { }
